// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__MissingDetailIcon__WjQqU{display:flex;width:25%;height:100%;align-items:center}
`, "",{"version":3,"sources":["webpack://./src/js/apps/components/common/MissingDetailIcon/styles.scss"],"names":[],"mappings":"AAAA,kCACI,YAAa,CACb,SAAU,CACV,WAAY,CACZ,kBAAmB","sourcesContent":[".MissingDetailIcon {\n    display: flex;\n    width: 25%;\n    height: 100%;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MissingDetailIcon": `styles__MissingDetailIcon__WjQqU`
};
export default ___CSS_LOADER_EXPORT___;
